import React from "react";
import { HistoryIcon, UsersIcon, BoxIcon } from "lucide-react";
export type ClinicianTab = 'queue' | 'completed';
type ClinicianServiceCardsProps = {
  activeTab: ClinicianTab;
  onSelect: (tab: ClinicianTab) => void;
};
const cards: Array<{
  tab: ClinicianTab;
  name: string;
  caption: string;
  icon: BoxIcon;
  bg: string;
  ring: string;
}> = [{
  tab: 'queue',
  name: 'Active Queue',
  caption: 'Patients awaiting consultation',
  icon: UsersIcon,
  bg: 'bg-[#2563EB]',
  ring: 'ring-[#2563EB]'
}, {
  tab: 'completed',
  name: 'Completed Consultations / History',
  caption: 'Past consultations',
  icon: HistoryIcon,
  bg: 'bg-[#E0106F]',
  ring: 'ring-[#E0106F]'
}];
export function ClinicianServiceCards({
  activeTab,
  onSelect
}: ClinicianServiceCardsProps) {
  return <div className="flex flex-wrap gap-3" data-id="element-2839" data-mp="1hwcqyizfleqx">
      {cards.map(({
      tab,
      name,
      caption,
      icon: Icon,
      bg,
      ring
    }) => {
      const isActive = activeTab === tab;
      return <button key={tab} type="button" onClick={() => onSelect(tab)} aria-pressed={isActive} className={`${bg} inline-flex max-w-full items-center gap-3 rounded-xl py-3 pl-3 pr-5 text-left text-white shadow-md shadow-gray-300/40 transition-transform duration-150 ease-out hover:-translate-y-0.5 focus:outline-none focus-visible:ring-4 focus-visible:ring-offset-2 ${ring} ${isActive ? 'ring-4 ring-offset-2 ring-offset-chrome-canvas' : ''}`} data-id="element-2840" data-mp="3jeuqq77iurp9">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white/20" data-id="element-2841" data-mp="30gs582e6ncw7">
              <Icon className="h-[18px] w-[18px] text-white" strokeWidth={2} aria-hidden="true" data-id="element-2842" data-mp="2viqecvaim9a6" />
            </span>
            <span data-id="element-2843" data-mp="3acd2jn8b3ozm">
              <span className="block whitespace-nowrap text-sm font-semibold leading-tight" data-id="element-2844" data-mp="35fcvpa3mui7g">
                {name}
              </span>
              <span className="block whitespace-nowrap text-xs text-white/85" data-id="element-2845" data-mp="pn5uh0rw5zt3">
                {caption}
              </span>
            </span>
          </button>;
    })}
    </div>;
}